import { useTranslation } from 'react-i18next'

export const usePages = () => {
  const [t] = useTranslation()
  const mortgagePage = {
    title: t('CalculatorPageMortgage.pageTitle', { defaultValue: 'Mortgage' }),
    urlPath: '/calculators/mortgage',
    partiallyActive: true,
  }
  const autoPage = {
    title: t('CalculatorPageAuto.pageTitle', { defaultValue: 'Auto' }),
    urlPath: '/calculators/auto',
    partiallyActive: true,
  }
  const personalFinancePage = {
    title: t('CalculatorPageFinance.pageTitle', { defaultValue: 'Personal Finance' }),
    urlPath: '/calculators/personal-finance',
    partiallyActive: true,
  }
  const wealthManagementPage = {
    title: t('CalculatorPageWealth.pageTitle', { defaultValue: 'Wealth Management' }),
    urlPath: '/calculators/wealth-management',
    partiallyActive: true,
  }
  const calculatorsPage = {
    title: t('CalculatorPageIndex.pageTitle', { defaultValue: 'Calculators' }),
    urlPath: '/calculators',
    children: [mortgagePage, autoPage, personalFinancePage, wealthManagementPage],
  }
  return {
    mortgagePage,
    autoPage,
    personalFinancePage,
    wealthManagementPage,
    calculatorsPage,
  }
}
